import React from "react";

export default function AcceptModal({ 
  show, 
  seller, 
  title = "Proposal was shortlisted", 
  description = "Proposal has been added to your Shortlisted list.",
  primaryLabel = "Go to Shortlisted",
  secondaryLabel = "Back to Proposals",
  onConfirm, 
  onCancel 
}) {
  if (!show || !seller) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 1200 }}
      onClick={onCancel}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "480px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content p-5 rounded-3">
          <div className="d-flex justify-content-center mb-3">
            <img
              src="/images/shortlisted.svg"
              alt={seller.name}
              className="rounded-circle"
              style={{ width: 90, height: 90, objectFit: "cover" }}
            />
          </div>

          <h5 className="fw-bold mb-2 text-center" style={{ color: "#071437" }}>
            {title}
          </h5>

          <p className="mb-4 text-center" style={{ color: "#80829A", fontSize: "14px" }}>
            {description}
          </p>

          <div className="d-flex justify-content-center gap-3">
            <button className="btn w-100 btn-outline-secondary px-4" onClick={onCancel}>
              {secondaryLabel}
            </button>
            <button
              className="btn w-100 px-4"
              style={{ backgroundColor: "#181D4C", color: "#fff" }}
              onClick={onConfirm}
            >
              {primaryLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
